import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {translate} from '@elements/translations';
import {findIn} from '@elements/dom-utils';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:

import * as formValidation from './scripts/form-validation';
formValidation.init();

import * as actionChanger from '@elements/action-changer';
actionChanger.init();